<div class="flex items-center gap-1.5" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <lepi-date-picker [value]="isOpen() ? tempStartAt() : startAt()" [hideOverlay]="true" (click)="openOverlay()" />
  <span class="icon-[mdi--arrow-right-thin] text-lg text-base-content/25 shrink-0"></span>
  <lepi-date-picker [value]="isOpen() ? tempEndAt() : endAt()" [hideOverlay]="true" (click)="openOverlay()" />
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayPositions]="overlayPositions"
  [cdkConnectedOverlayPush]="true"
  (detach)="handleCancel()"
  (overlayOutsideClick)="handleCancel()">
  <div
    class="calendar-popup rounded-xl shadow-xl border border-base-300 bg-base-100 overflow-hidden mt-1 flex flex-col min-w-[320px]">
    <lepi-pick-calendar [(startAt)]="tempStartAt" [(endAt)]="tempEndAt" mode="range" />

    <div class="flex justify-end p-3 border-t border-base-content/5 gap-2">
      <button class="btn btn-ghost btn-sm" (click)="handleCancel()">취소</button>
      <button class="btn btn-primary btn-sm" (click)="handleApply()">적용</button>
    </div>
  </div>
</ng-template>
